// Sopwith 3D - simulation constants.
//
// Copyright (C) 1984-2000 David L. Clark
// Copyright (C) 2001-2026 Simon Howard and SDL Sopwith contributors
// Copyright (C) 2026 Sopwith 3D contributors
//
// This program is free software; you can redistribute it and/or modify it
// under the terms of the GNU General Public License as published by the Free
// Software Foundation; either version 2 of the License, or (at your option)
// any later version. This program is distributed WITHOUT ANY WARRANTY.
//
// Ported from SDL Sopwith (sw.h, swmain.c, swmove.c). Every value here is in
// simulation units: one tick is 1/FPS of a second and one unit of distance is
// one pixel of the original 320x200 display.

/** Simulation ticks per second. */
export const FPS = 10;

/** Highest Y coordinate (the world is MAX_Y units tall; y grows upward). */
export const MAX_Y = 200;

export const MIN_SPEED = 4;
export const MAX_SPEED = 8;
export const MAX_THROTTLE = 4;

export const MAXCRCOUNT = 10; // ticks spent crashed
export const FALLCOUNT = 10; // ticks between falling-plane adjustments
export const STALLCOUNT = 6; // ticks between stalling-plane adjustments
export const TARGHITCOUNT = 10; // bullet hits before a target explodes

export const SCR_WDTH = 320;
export const SCR_HGHT = 200;
export const SCR_CENTR = SCR_WDTH / 2 - 8; // column the player is kept at
export const SCR_MNSH = 16; // vertical scroll dead-zone (min row)
export const SCR_MXSH = 75; // vertical scroll dead-zone (max row)

export const MAXROUNDS = 200;
export const MAXBOMBS = 5;
export const MAXMISSILES = 5;
export const MAXBURSTS = 5;
export const MAXFUEL = 9000; // ticks worth of fuel (consumed by speed per tick)
export const MAXCRASH = 5; // lives

export const MAX_PLANES = 16;
export const MAX_PLYR = 4;
export const MAX_OBJS = 100;
export const NUM_STRAY_BIRDS = 1;

export const ANGLES = 16;
export const ORIENTS = 2;
export const SYM_WDTH = 16;
export const SYM_HGHT = 16;

export const BULSPEED = 10;
export const BULLIFE = 10;
export const BOMBLIFE = 5;
export const MISSLIFE = 50;
export const BURSTLIFE = 20;
export const EXPLLIFE = 3;
export const SMOKELIFE = 10;
export const BIRDLIFE = 4;
export const FLOCKLIFE = 5;

export const NEAR = 150 * 150; // AI: squared distance to notice a target
export const CLOSE = 32; // AI: pursuit offset
export const HOME = 16; // AI: landing radius
export const SAFERESET = 32; // crash near home => longer rebuild

export const QUIT = -5000; // plane life value when quitting

/** Number of ticks of commands buffered per player (lockstep ring size). */
export const MAX_NET_LAG = 12;

// Keyboard command bitmask (one word per player per tick).
export const K_ACCEL = 0x0001;
export const K_DEACC = 0x0002;
export const K_FLAPU = 0x0004;
export const K_FLAPD = 0x0008;
export const K_FLIP = 0x0010;
export const K_SHOT = 0x0020;
export const K_HARRYKEYS = 0x0040; // pitch keys are screen-relative when flipped
export const K_BOMB = 0x0100;
export const K_HOME = 0x0200;
export const K_SOUND = 0x0400;
export const K_BREAK = 0x0800;
export const K_MISSILE = 0x1000;
export const K_STARBURST = 0x2000;

/** sin() for the 16 headings, scaled by 256. */
export const SINTAB: readonly number[] = [
  0, 98, 181, 237, 256, 237, 181, 98, 0, -98, -181, -237, -256, -237, -181, -98,
];

/** Speed bias applied per heading: diving speeds up, climbing slows down. */
export const GRAVITY: readonly number[] = [0, -1, -2, -3, -4, -3, -2, -1, 0, 1, 2, 3, 4, 3, 2, 1];

export const NUM_TARGET_TYPES = 20;
export const NUM_POWERUP_TYPES = 6;
